<template>
  <b-modal centered id="vote-modify" title="票数编辑" scrollable v-model="modalShow">
    <b-container fluid>
      <b-row>
        <b-col sm="3">
          <label>当前票数:</label>
        </b-col>
        <b-col sm="9">{{ info.curVotes }}</b-col>
      </b-row>
      <b-row>
        <b-col sm="3">
          <label>增减票数:</label>
        </b-col>
        <b-col sm="9">
          <b-form-input type="number" v-model="modifyVotes" :min="min" />
        </b-col>
      </b-row>
      <br>
    </b-container>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="danger" @click="cancel()">
        取消
      </b-button>
      <b-button size="sm" variant="success" @click="modifyVote">
        提交
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import api from '@/utils/api'
import Error from '@/mixin/error'

export default {
  name: 'vote-item-votes-modify',
  mixins: [Error],
  data () {
    return {
      modalShow: false,
      modifyVotes: 0,
      info: {
        curVotes: 0,
        appId: null,
        voteId: null
      },
      min: -99
    }
  },
  methods: {
    show (info) {
      this.info = info
      this.modifyVotes = 0
      this.min = -info.curVotes
      this.modalShow = true
    },
    modifyVote () {
      if (!this.modifyVotes) {
        this.$message.warning('增减数有误')
        return
      }
      let data = {
        app_id: this.info.appId,
        vote_id: this.info.voteId,
        vote_number: this.modifyVotes
      }
      api.createVoteData(this, api.getCheatVote(), 'POST', data, this.oversea, this.modifyCallback, false)
    },
    modifyCallback () {
      this.$message.success('更新成功')
      this.$emit('finish')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// VoteItemVotesModify.vue?1e9bdd82